import React, {Component} from 'react'
import {Button, Modal, Nav} from 'react-bootstrap'
import {NavLink} from 'react-router-dom'
// import { _Api } from "../../services/Api";
// import Url from "../../services/BaseUrl";


class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logout: false,
            showmobile: false
        };

    }

    // UNSAFE_componentWillReceiveProps(props) {
    //     let self = this;
    //     if (props !== undefined) {
    //         if (!_.isEmpty(props)) {
    //             if (props.profilePicPreview) {
    //
    //                 self.setState({
    //                     profilePicPreview: props.profilePicPreview? props.profilePicPreview:this.state.profilePicPreview,
    //
    //
    //                 })
    //             }
    //         }
    //     }
    // }


    menushow = () => {
        this.setState({
            showmobile: !this.state.showmobile
        })
    }


    componentDidMount() {

        // this.getUserInfo()

    }


    // getUserInfo = () => {
    //     this.setState({ errors: '' });
    //     const { onRefreshEditProfile} = this.props
    //     let self = this
    //     this.setState({ redirect: false, loader: true });
    //
    //
    //     _Api(Url.SUPER_ADMIN_VIEW_PROFILE.method, Url.SUPER_ADMIN_VIEW_PROFILE.url, '',)
    //         .then((data) => {
    //             this.setState({ loader: false })
    //             if (data.statusCode == 1) {
    //                 let userInfo = data.responseData.adminProfile
    //                 this.setState({
    //                     userInfo: userInfo,
    //
    //                     name: userInfo.name,
    //                     phone: userInfo.phone,
    //                     email: userInfo.email,
    //                     address: userInfo.address,
    //                     profilePic: userInfo.profileImage,
    //                     profilePicPreview: userInfo.profileImage,
    //                 })
    //             } else {
    //                 this.setState({ errors: data.error.responseMessage })
    //             }
    //         });
    // }


    Closelogout = () => {
        this.setState({logout: false})
    }
    handleLogoutAdmin = () => {

        this.setState({logoutdeletePopup: true})
        localStorage.removeItem('accessToken');
        window.location.href = '/';

    }

    openPopup = () => {
        this.setState({logout: true})
    }

    render() {
        let {logout, profilePicPreview, showmobile} = this.state
        return (
          <>
            <div
              className={`mobile-logo-wrapper${showmobile ? " is-open" : ""}`}
            >
              <span className="mobile-logo-text">Date Dish</span>
            </div>
            <div className="mobile-trigger-wrapper" onClick={this.menushow}>
              <span className="mobile-trigger">
                <i className="fas fa-bars"></i>
              </span>
            </div>
            {showmobile && (
              <div className="sidebar-overlay" onClick={this.menushow}></div>
            )}
            <div className={showmobile ? "sidebar open" : "sidebar"}>
              {/* <div className="toggle_icon_menu">
                    <button className="btn" type="button" ><i className="fas fa-bars"></i></button>
                </div> */}
              <div className="farmerlogowrapper">
                {/*{profilePicPreview ? <img className="rounded-circle1" src={require('../../assets/img/datedish logo .png')} />:*/}
                <img
                  className="rounded-circle1"
                  src={require("../../assets/img/DDlogo.png")}
                />
                {/*// }*/}
                {/* <h6>Date dish</h6> */}
              </div>

              <div>
                <div className="sidebar_menu">
                  <Nav.Item>
                    <NavLink to="/users">
                      <div className="sidebar-item-icon">
                        <i className="fa fa-users" aria-hidden="true"></i>
                      </div>
                      Users
                    </NavLink>
                  </Nav.Item>

                  <Nav.Item>
                    <NavLink to="/community">
                      <div className="sidebar-item-icon">
                        <i className="fa fa-newspaper" aria-hidden="true"></i>
                      </div>
                      Community Posts
                    </NavLink>
                  </Nav.Item>
                  {/* <Nav.Item>

                                <NavLink to="/reasons">
                                    <div className="sidebar-item-icon">
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </div>
                                    Reasons</NavLink>
                            </Nav.Item> */}
                  <Nav.Item>
                    <NavLink to="/reports">
                      <div className="sidebar-item-icon">
                        <i
                          className="fa fa-exclamation-circle"
                          aria-hidden="true"
                        ></i>
                      </div>
                      Reports
                    </NavLink>
                  </Nav.Item>

                  <Nav.Item>
                    <NavLink to="/trust-score">
                      <div className="sidebar-item-icon">
                        <i className="fas fa-shield-alt" aria-hidden="true"></i>
                      </div>
                      Trust Score
                    </NavLink>
                  </Nav.Item>

                  <Nav.Item>
                    <NavLink to="/settings">
                      <div className="sidebar-item-icon">
                        <i className="fa fa-cog" aria-hidden="true"></i>
                      </div>
                      Settings
                    </NavLink>
                  </Nav.Item>

                  {/* <Nav.Item>

                                <NavLink to="/address">
                                    <div className="sidebar-item-icon">
                                        <i className="fa fa-city" aria-hidden="true"></i>

                                    </div>
                                    Cities</NavLink>
                            </Nav.Item> */}
                </div>
                <div className="sidebar_button">
                  <Button variant="info" onClick={this.openPopup}>
                    Logout
                  </Button>
                </div>
              </div>
            </div>

            <Modal
              show={logout}
              onHide={this.Closelogout}
              className="cm_order_view dlt_item"
              centered
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p>Are you sure you want to logout?</p>
              </Modal.Body>
              <Modal.Footer>
                <div className="footer_btn_wrapper button_space">
                  <Button variant="info" onClick={this.handleLogoutAdmin}>
                    Yes
                  </Button>
                  <Button variant="dark" onClick={this.Closelogout}>
                    No
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          </>
        );
    }
}

export default Sidebar;
